// src/features/dashboard/components/RecentActivity.tsx
import { RecentTicketsList } from './RecentTicketsList';
import { ActivityTimeline } from './ActivityTimeline';
import type { RecentTicket, TimelineEvent } from '../types/dashboard.types';

interface RecentActivityProps {
  tickets: RecentTicket[];
  events: TimelineEvent[];
  isInitialLoading: boolean;
}

/**
 * Combines `RecentTicketsList` and `ActivityTimeline` into a single
 * "recent activity" unit for the side column. Each child keeps its own
 * `GlassCard` surface and internal markup untouched -- this component only
 * stacks them and forwards props, so both remain independently reusable
 * elsewhere. `RecentOrdersTable` is an operational table and stays out of
 * this grouping, per the approved composition.
 */
export function RecentActivity({ tickets, events, isInitialLoading }: RecentActivityProps) {
  return (
    <div className="flex flex-col gap-5 vania-activity-group">
      <RecentTicketsList tickets={tickets} isInitialLoading={isInitialLoading} />
      <ActivityTimeline events={events} isInitialLoading={isInitialLoading} />
    </div>
  );
}
